/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "beemo": {
        "nested": {
          "api": {
            "nested": {
              "v4": {
                "nested": {
                  "FulfillmentRecipient": {
                    "fields": {
                      "customerId": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "displayName": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "emailAddress": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      },
                      "phoneNumber": {
                        "type": "string",
                        "id": 4,
                        "rule": "optional"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v4?.nested?.FulfillmentRecipient) {
  $root.addJSON(jsonData);
}

/**
 * Converted from FulfillmentRecipient
 * https://prototype.sqprod.co/#/docs/squareup.omg.fulfillment.FulfillmentRecipient
 *
 * SOURCE FulfillmentRecipient @ squareup/beemo/v4/fulfillment.proto at 29:1
 */
export const FulfillmentRecipient = $root.lookupType('squareup.beemo.api.v4.FulfillmentRecipient');
fixType(FulfillmentRecipient);
Builder.createAndAttachToType(FulfillmentRecipient);